import Typography from '@mui/material/Typography'
import { memo } from 'react'

import IconNoData from '@/components/base/IconNoData'
import useTrans from '@/hooks/useTrans'

import { StyledTableCell,StyledTableRow } from './styles'

const View = ({ colSpan }: { colSpan: number }) => {
  const trans = useTrans()

  return (
    <StyledTableRow data-testid="top-coins-empty-row">
      <StyledTableCell colSpan={colSpan} align="center">
        <IconNoData />
        <Typography className="text-sm mt-2 text-[#B0B2BE]">{trans.no_data}</Typography>
      </StyledTableCell>
    </StyledTableRow>
  )
}

export default memo(View)
